// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"ef699e24","453":"6a6c4e7f","478":"9e27d82c","587":"aedbf7d5","607":"fafe4f5d","702":"c359106d","865":"ea6e67ac"}[chunkId] + ".chunk.js";
};